import { ChangeDetectionStrategy, Component, Input, Renderer2, OnInit } from '@angular/core'
import { Validators } from '@angular/forms'

import { ValidatorFactories } from '../../../core/validators'
import { FormComponent } from '../../../core/base/form-component'
import { FormsService } from '../../../core/services/forms.service'

const passwordValidator = ValidatorFactories.password(6, false, true, true, true)

@Component({
  selector: 'app-reset-password-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResetPasswordPageComponent extends FormComponent implements OnInit {
  @Input() isResetLinkValidationCompleted: boolean
  @Input() isResetLinkValid: boolean

  constructor(
    private forms: FormsService,
    private renderer: Renderer2
  ) {
    super()

    this.form = forms.group({
      password: [
        '', [Validators.required, passwordValidator], 'reset.fields.password'
      ]
    })
  }

  ngOnInit() {
    // add login class to body for background image
    this.renderer.addClass(document.body, 'login');
  }

  ngOnDestroy() {
    // remove login class
    this.renderer.removeClass(document.body, 'login');
  }

}
